/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Stringcontainsandaspect13Inputs */



/**

* @param {_Filter_Class_Stringcontainsandaspect13Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_stringcontainsandaspect13 = /** @type {((inputs?: _Filter_Class_Stringcontainsandaspect13Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Stringcontainsandaspect13Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("beinhaltet alle von")
});
export { _filter_class_stringcontainsandaspect13 as "_filter_class_StringCONTAINSANDAspect" }